import React, { FC, useEffect, useRef, useState } from "react";
import { Document, Page } from "react-pdf";
import type { PDFDocumentProxy } from "pdfjs-dist";

import { useAppSelector } from "../../store";

import { getTournoi } from "../../features/tournoi/tournoiSlice";

interface RulesProps {}

const Rules: FC<RulesProps> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number | null>(null);
  const [numPages, setNumPages] = useState<number | null>(null);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const handleLoadSuccess = (pdf: PDFDocumentProxy) => {
    setNumPages(pdf.numPages);
  };

  const handleLoadError = (error: Error) => {
    console.error("❌ Erreur lors du chargement du PDF :", error);
  };

  const tournoi = useAppSelector(getTournoi);

  if (!tournoi) {
    return <></>;
  }

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <Document
        file={encodeURI(`/${tournoi?.reglement}`)}
        onLoadSuccess={handleLoadSuccess}
        loading="Chargement du document..."
        onLoadError={handleLoadError}
      >
        {Array.from(new Array(numPages || 0), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={width || 600} // largeur adaptative
          />
        ))}
      </Document>
    </div>
  );
};

export default Rules;
